import { Dialog} from 'quasar';
import { Camera, CameraResultType, Photo } from '@capacitor/camera';

export default class CameraHelper {
  static async GetImage(callbackFunction: ( photo : Photo | null) => Promise<void>) {
    try{
    
      const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: true,
      resultType: CameraResultType.Uri
      });

      if(image) {
        // image.webPath will contain a path that can be set as an image src.
        // You can access the original file using image.path, which can be
        // passed to the Filesystem API to read the raw data of the image,
        // if desired (or pass resultType: CameraResultType.Base64 to getPhoto)
        const imageUrl = image.webPath;


        Dialog.create({
          title: 'Do you want to use this image?',
          message: `<img v-if="imageSrc" src="${<string>imageUrl}" class="full-width" />`,
          html: true,
          ok: 'Yes',
          cancel: true,
          persistent: true,
          }).onOk(async () => {
            await callbackFunction(image);
          })
      }
    }
    catch(err) {
      console.log(err);
    }
  }
}
